<script setup>
import ServerError from '@components/errors/ServerError.vue'
import InitializeAppError from '@components/errors/InitializeAppError.vue'
import NotFoundError from '@components/errors/NotFoundError.vue'
const props = defineProps({
  errorType: {
    type: String,
    required: true
  }
})
const errorComponentMap = {
  serverError: ServerError,
  initializeAppError: InitializeAppError,
  NotFoundError
}
</script>

<template>
  <div class="l-page">
    <div class="l-page__wrapper">
      <component :is="errorComponentMap[props.errorType]" />
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>
